/* bamboofits — ürün vitrini varyant seçimi */
if (!customElements.get('bf-showcase')) {
  class BfShowcase extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-bf-variants]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-bf-labels]').textContent);
      } catch (e) {
        return;
      }
      this.idInput = this.querySelector('[data-bf-id]');
      this.price = this.querySelector('[data-bf-price]');
      this.button = this.querySelector('[data-bf-atc]');
      this.msg = this.querySelector('[data-bf-msg]');
      this.section = this.closest('section');
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-bf-option]')) this.update();
      });
    }

    selectedOptions() {
      const groups = {};
      this.querySelectorAll('[data-bf-option]:checked').forEach((input) => {
        groups[input.dataset.bfOption] = input.value;
      });
      return Object.keys(groups)
        .sort()
        .map((key) => groups[key]);
    }

    formatMoney(cents) {
      const format = this.labels.moneyFormat || '{{amount_with_comma_separator}} TL';
      const value = (cents / 100).toFixed(2);
      const [whole, decimals] = value.split('.');
      const dot = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const comma = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
        switch (key) {
          case 'amount_with_comma_separator':
            return `${dot},${decimals}`;
          case 'amount_no_decimals_with_comma_separator':
            return dot;
          case 'amount_no_decimals':
            return comma;
          default:
            return `${comma}.${decimals}`;
        }
      });
    }

    update() {
      const selected = this.selectedOptions();
      const variant = this.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));

      if (!variant) {
        this.button.disabled = true;
        this.button.textContent = this.labels.unavailable;
        this.msg.textContent = this.labels.unavailable;
        return;
      }

      this.msg.textContent = '';
      this.idInput.value = variant.id;
      this.button.disabled = !variant.available;
      this.button.textContent = variant.available ? this.labels.add : this.labels.soldout;

      let html = this.formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ` <s class="bf-small bf-muted">${this.formatMoney(variant.compare_at_price)}</s>`;
      }
      this.price.innerHTML = html;

      if (variant.featured_image && this.section) {
        const img = this.section.querySelector('[data-bf-media] img');
        if (img) {
          img.removeAttribute('srcset');
          img.src = variant.featured_image.src;
          img.alt = variant.featured_image.alt || variant.name;
        }
      }
    }
  }

  customElements.define('bf-showcase', BfShowcase);
}
